module.exports = "/images/storm@3x.png?254bdd1ee56b06c044d8c0c4107a8377";